import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/smarthomepanel/pc/');

export default function Comp({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('smarthomepanel');

    return (
        <div className={`${css.gsapA4} gsapA4`}>
            <div className="msg-title msg-title1">
                <p
                    dangerouslySetInnerHTML={{
                        __html: t('smart_home_panel.four_des_pc'),
                    }}
                ></p>
            </div>
            <div className="msg-title msg-title2">
                {t('smart_home_panel.five_or')}
                <span className="msg-color1"> {t('smart_home_panel.five_white_text')} </span>
                {t('smart_home_panel.five_gray_text')}
            </div>
            <div className="img-box img-box1">
                <EFPic
                    name={["img_house_1.webp", "img_house_1.jpg"]}
                    alt={t('smart_home_panel.four_title')}
                />
            </div>
            <div className="img-box img-box2">
                <EFPic
                    name={["img_house_2.webp", "img_house_2.jpg"]}
                    alt={t('Smart Home Panel')}
                />
            </div>
        </div>
    );
}
